angular
  .module('countriesApp')
  .service('RequestService', [
    'ApiService',
    'RequestHelperService',
    'RELATIVE_PATHS',
    'API_PATHS',
    function (Api, RequestHelper, RELATIVE_PATHS, API_PATHS) {
      /**
       * Performs a GET request to the list of countries from the API endpoint
       *
       * @returns {object} - Request promise object
       */
      const getCountries = () => Api.get(API_PATHS.COUNTRIES);

      /**
       * Performs a GET request to the countries API endpoint
       * If there is no defined id for the URL, it rejects the promise
       *
       * @param {string} id - Country id for the URL
       *
       * @returns {object} - Request promise object
       */
      const getCountry = id => {
        if(!id) {
          return RequestHelper.rejectPromise('No country id specified');
        }

        return Api.get(`${ API_PATHS.COUNTRIES }/${ id }`);
      };

      /**
       * Performs GET request to articles API endpoint with the given Country ID
       * If there is no defined ID, it rejects the promise
       *
       * @param {string} id - Country id for the URL
       *
       * @returns {object} - Request promise object
       */
      const getCountryArticles = id => {
        if(!id) {
          return RequestHelper.rejectPromise('No country ID specified');
        }

        return Api.get(`${ API_PATHS.COUNTRIES }/${ id }/articles`);
      };

      /**
       * Performs GET request to jobs API endpoint with the given Country ID
       * If there is no defined ID, it rejects the promise
       *
       * @param {string} id - Country id for the URL
       *
       * @returns {object} - Request promise object
       */
      const getCountryJobs = id => {
        if(!id) {
          return RequestHelper.rejectPromise('No country ID specified');
        }

        return Api.get(`${ API_PATHS.COUNTRIES }/${ id }/jobs`);
      };

      /**
       * Performs GET request to consultants API endpoint with the given Country ID
       * If there is no defined ID, it rejects the promise
       *
       * @param {string} id - Country id for the URL
       *
       * @returns {object} - Request promise object
       **/
      const getCountryConsultants = id => {
        if(!id) {
          return RequestHelper.rejectPromise('No country ID specified');
        }

        return Api.get(`${ API_PATHS.COUNTRIES }/${ id }/consultants`);
      };

      /**
       * Performs GET request to companies API endpoint with the given Country ID
       * If there is no defined ID, it rejects the promise
       *
       * @param {string} id - Country id for the URL
       *
       * @returns {object} - Request promise object
       */
      const getCountryCompanies = id => {
        if(!id) {
          return RequestHelper.rejectPromise('No country ID specified');
        }

        return Api.get(`${ API_PATHS.COUNTRIES }/${ id }/companies`);
      };

      /**
       * Performs GET request to a specific country funding reports API endpoints. The final GET URL
       * is determined by type param passed by funding_reports service.
       * If there is no defined country ID, it rejects the promise
       *
       * @param {number} id - Country ID, used in URL
       * @param {string} type - Type of funding report the BE should return
       *
       * @returns {object} - Request promise object
       */
      const getFundingReportsByCountry = (id, type) => {
        if(!id) {
          return RequestHelper.rejectPromise('No country ID specified');
        } else if(!type) {
          return RequestHelper.rejectPromise('No funding report type specified');
        }

        return Api.get(`${ API_PATHS.COUNTRIES }/${ id }/${ RELATIVE_PATHS[type] }`);
      };

      /**
       * Performs GET request to country sectors aggregations API endpoint.
       * If there is no defined country ID for the URL, it rejects the promise
       *
       * @param {number} id - Country ID, used in URL
       *
       * @returns {object} - Request promise object
       */
      const getAggregatedSectorsByCountry = id => {
        if(!id) {
          return RequestHelper.rejectPromise('No country ID specified');
        }

        return Api.get(`${ API_PATHS.COUNTRIES }/${ id }/${ RELATIVE_PATHS.AGGREGATED_SECTORS }`);
      };

      /**
       * Performs GET request to country donors aggregations API endpoint.
       * If there is no defined country ID for the URL, it rejects the promise
       *
       * @param {number} id - Country ID, used in URL
       *
       * @returns {object} - Request promise object
       */
      const getAggregatedDonorsByCountry = id => {
        if(!id) {
          return RequestHelper.rejectPromise('No country ID specified');
        }

        return Api.get(`${ API_PATHS.COUNTRIES }/${ id }/${ RELATIVE_PATHS.AGGREGATED_FUNDERS }`);
      };

      return {
        getCountries,
        getCountry,
        getCountryArticles,
        getCountryCompanies,
        getCountryJobs,
        getCountryConsultants,
        getFundingReportsByCountry,
        getAggregatedSectorsByCountry,
        getAggregatedDonorsByCountry
      };
    }
  ]);
